module.exports = __webpack_public_path__ + "img/file-earmark-post-fill.306f0abf.svg";